module.exports = __webpack_public_path__ + "img/survey.3ca3d90b.svg";